<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title>Información Admin Inge</mat-card-title>
        <button mat-icon-button (click)="cerrarDialogo()" style="position: absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
  <mat-card-content>
    <table class="table table-bordered text-center">
      <tr>
        <th>Propiedad</th>
        <th>Valor</th>
      </tr>
      <tr>
        <td>Fecha Inicio de actividades</td>
        <td>{{ data.startDate | date : "dd/MM/yyyy" }}</td>
      </tr>
      <tr>
        <td>Dias desde inicio actividades</td>
        <td>{{ data.startDate==null? "Sin información" : data.startDateFromNow + ' Días' }}</td>
      </tr>
      <tr>
        <td>Fecha registro en el sistema</td>
        <td>{{ data.inserted | date : "dd/MM/yyyy"}}</td>
      </tr>
      <tr>
        <td>Ejecutivo actual</td>
        <td>{{ data.executive }}</td>
      </tr>
      <tr>
        <td>Primera adjudicación</td>
        <td>{{ data.firstAdjudication | date : "dd/MM/yyyy"}}</td>
      </tr>
      <tr>
        <td>Dias desde primera adjudicación</td>
        <td>{{ data.firstAdjudicationFromNow + ' Dias' }}</td>
      </tr>
      <tr>
        <td>Máxima adjudicación</td>
        <td>{{ data.maxAdjudication | currency:'CLP' }}</td>
      </tr>
      <tr>
        <td>Linea</td>
        <td>{{ data.linea | currency:'CLP' }}</td>
      </tr>
      <tr>
        <td>Linea utilizada</td>
        <td>{{ data.totalUsedLine | currency:'CLP' }}</td>
      </tr>
      <tr>
        <td>Linea disponible</td>
        <td>{{ data.availableLine | currency:'CLP' }}</td>
      </tr>
      <tr>
        <td>Total riesgo tomado</td>
        <td>{{ data.totalRiskTaken | currency:'CLP' }}</td>
      </tr>
      <tr>
        <td>Garantías vigentes</td>
        <td>{{ data.availableWarrantiesCount }}</td>
      </tr>
      <tr>
        <td>Total garantías emitidas</td>
        <td>{{ data.totalWarrantiesCount }}</td>
      </tr>
      
      <tr>
        <td>Úlitmo scoring</td>
        <td>{{ data.lastScoringStateDescription }}</td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>

